import React from 'react';

import {
  SearchResult,
} from '../../../components';

import GroupedContentFull from '../GroupedContent/Full';
import InterviewTeaser from './teaser';
import InterviewTeaserLarge from './teaser_large';

const Interview = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser':
      return (<InterviewTeaser entity={entity} {...props} />);
    case 'teaser_large':
      return (<InterviewTeaserLarge entity={entity} {...props} />);
    case 'full':
    default:
      return (<GroupedContentFull entity={entity} {...props} />);
  }
};

export default Interview;
